const SEO = [
	{
		page: "home",
		description:
			"I am a backend software engineer with expertise in Node.js, Typescript and PostgreSQL. I design and build scalable, robust and maintainable backend systems.",
		keywords: ["Ian", "Ian K", "Ian Kibandi", "Kibandi", "Backend Developer", "Freelance", "Backend Software Engineer", "Software Architect"],
	},

	{
		page: "about",
		description:
			"I am a backend software engineer with expertise in Node.js, Typescript and PostgreSQL. I design and build scalable, robust and maintainable backend systems.",
		keywords: ["Ian", "Ian K", "Ian Kibandi", "Kibandi", "Software Engineer", "Kenya"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Ian", "Ian K", "Ian Kibandi", "Kibandi"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Ian", "Ian K", "Ian Kibandi", "Kibandi"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Ian", "Ian K", "Ian Kibandi", "Kibandi"],
	},
];

export default SEO;
